import * as React from "react";
import { SVGProps } from "react";

const Ternio = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 456 456" {...props}>
    <circle cx={228.1} cy={228.1} r={228.1} fill="#1b2d45" />
    <path
      fill="#719cd0"
      d="M357.2 209.6v-56L228.1 78.9l-66.7 38.6 52.8 30.9-13.1 8.4-53.3-31.4L99 153.7l.2 149.3 66.9 38.3v-60.6l12.8 7.4v60.5l50 28.9 128.4-75v-77.8l-52 30.5v-14.8Zm-191.5-17.5 7.1-3.9 52.6 30.4 56-31.3 8.4 4.8v8.4l-53 30.8v63l-8.7 5.9-6.8-4.8v-60.3l-55.6-32.5Zm28.4 73-55-30.3v60.3l-14.3-8.1-.3-117.8 22-13.1 13.5 8.4-21.5 13 .1 39.8 55.4 32.5v15.3Zm137.2 6.2v16.3l-103.6 59.6-21.8-12.9v-15.5l22.2 12.5 35.6-20.6v-64.1l13.4-8.6.4 64.5ZM281.1 156l-55.3 32-12.3-7.6 54-31.9-53.1-30.7 13.7-8 102.8 59.6v24.8l-14.4 8.5v-25.5Z"
    />
  </svg>
);

export default Ternio;
